<template>
  <div id="Contact" class="Page Contact" v-if="response">

    <section id="Top" class="Section Coordinates">
      <div class="Coordinates_wrapper">
        <div class="Coordinates_content">
          <div class="Coordinates_text">
            <img src="/assets/images/wave-top.svg"/>
            <h3>{{ response[0].primary.schedule_title }}</h3>
            <h2>{{ response[0].primary.schedule_label }}</h2>
              <prismic-rich-text :field="response[0].primary.schedule_paragraph" v-if="true" :field-content="response[0].primary.schedule_paragraph" />
            <div class="Coordinates_link">
              <a target="_blank" :href="response[0].primary.phone_link.url">{{ response[0].primary.phone_label }}</a>
            </div>
            <div v-if="response[0].primary.booking_link.url && response[0].primary.booking_label" class="Coordinates_link">
              <a :target="response[0].primary.booking_link.target" :href="response[0].primary.booking_link.url" class="Cta" >{{ response[0].primary.booking_label }}</a>
            </div>
            <img src="/assets/images/wave-down.svg"/>
          </div>

          <div class="Coordinates_map" >
            <iframe :src=" response[1].primary.maps_link.url " frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </div>
        </div>
      </div>
    </section>

     <section class="Section Socials" >
      <div class="Socials_wrapper">
        <div class="Socials_content">
          <div class="Socials_text">
            <img src="/assets/images/wave-top.svg"/>
            <h3>{{ response[2].primary.title }}</h3>
            <h2>{{ response[2].primary.label }}</h2>
              <p>{{ response[2].primary.paragraphe }}</p>
            <div class="Socials_icon" >
              <a v-for="(social, i) in response[2].items" :key="i" :href="social.link.url" target="_blank"><i :class="social.icon"></i></a>
            </div>
            <img src="/assets/images/wave-down.svg"/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"
import PrismicFetch from "@/mixins/prismicFetch"

import ScrollParallax from "@/components/ScrollParallax"
import Fade from "@/components/Fade"
import Footer from "@/components/partials/Footer"

export default {
  components: {
    ScrollParallax,
    Fade,
    Footer
  },
  mixins: [ page, PrismicFetch ],
  data () {
    return {
      data: null
    }
  },
  head: {
    title: {
      inner: "So Beautiful By Sarah",
      separator: '/',
      complement: 'Contact'
    }
  },
  created () {
    this.getContent('contact')
  }
}
</script>

<style lang="stylus" scoped>
.Coordinates, .Socials

  a:hover
    color $dark-brown

  &_wrapper
    padding 60px 0

    @media $xsmall
      padding 40px 0

  &_text
    color $dark-brown
    width 500px
    margin 0 auto
    text-align center

    @media $small
      width 90%

    h3
      color $light-brown

    img
      position relative
      width 350px

      &:first-child
        left 90px
        top 20px
        transform translateY(-20px)

        @media $xsmall
          left 50px

      &:last-child
        right 90px
        top 20px
        transform translateY(-20px)

        @media $xsmall
          right 50px

      @media $small
        width 250px

      @media $xsmall
        width 200px

  &_link
    padding-top 20px

  &_map
    width 90%
    max-width $max-width
    margin 0 auto
    padding-top 60px

    iframe
      width 100%
      height 450px

      @media $medium
        height 400px

      @media $small
        height 380px

  &_icon
    margin-top 40px

    a
      margin-right 15px

      &:last-child
        margin-right 0

    i
      font-size 25px

.Socials

  &_wrapper
    padding-top 0
</style>
